import { isDefined } from "@clipboard-health/util-ts";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { useHistory, useLocation } from "react-router-dom";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { PLACEMENT_PATHS } from "../../../paths";

interface PlacementDetailsPageHeaderProps {
  placement: PlacementWithDetails;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  onFavoritePlacementChange: () => Promise<void>;
  isUpdatingFavoritedStatus: boolean;
}

export function PlacementDetailsPageHeader(props: PlacementDetailsPageHeaderProps) {
  const { placement, scrollContainerRef, isUpdatingFavoritedStatus, onFavoritePlacementChange } =
    props;
  const history = useHistory();
  const location = useLocation();

  function handleBackClick() {
    // Check both that we have a location key AND meaningful history to go back to
    // history.length <= 2 means we're at the first page (e.g., fresh deep link entry)
    if (isDefined(location.key) && history.length > 2) {
      history.goBack();
    } else {
      // No history to go back to (fresh deep link) or manual URL entry - navigate to placement root
      history.replace(PLACEMENT_PATHS.ROOT);
    }
  }

  const { title, isFavorited } = placement;

  return (
    <StickyScrollPageHeader
      shouldWrapTitle
      headerVariant="tertiary"
      title={title}
      scrollContainerRef={scrollContainerRef}
      rightAction={
        <IconButton
          disabled={isUpdatingFavoritedStatus}
          iconType={isFavorited ? "like-filled" : "like-outlined"}
          variant="outlined"
          onClick={onFavoritePlacementChange}
        />
      }
      onClickBack={() => {
        handleBackClick();
      }}
    />
  );
}
